export default "__VITE_ASSET__CELV3lcp__"